module.exports = __webpack_public_path__ + "img/wuhandaxues.0d268ef4.png";